import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CodigoAcessoComponent } from './codigo-acesso.component';

@NgModule({
  declarations: [CodigoAcessoComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [CodigoAcessoComponent]
})
export class CodigoAcessoModule { }
